"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var button = {
  icon: _propTypes.default.string,
  key: _propTypes.default.string,
  textColor: _propTypes.default.string,
  bgColor: _propTypes.default.string,
  borderColor: _propTypes.default.string
};
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    locale: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    translation: _propTypes.default.shape({
      pendingPayment: _propTypes.default.string,
      referenceNumber: _propTypes.default.string,
      applicationSuccessful: _propTypes.default.string,
      refundMessage: _propTypes.default.string,
      bookingProcessing: _propTypes.default.string,
      manageBooking: _propTypes.default.string,
      downloadItienairy: _propTypes.default.string,
      payNow: _propTypes.default.string,
      paymentPending: _propTypes.default.string,
      bookingNumber: _propTypes.default.string,
      viewEboardingPass: _propTypes.default.string,
      checkIn: _propTypes.default.string
    }).isRequired,
    state: _propTypes.default.string.isRequired,
    data: _propTypes.default.shape({
      bookingStatus: _propTypes.default.string,
      showTimer: _propTypes.default.bool,
      holdExpiry: _propTypes.default.string,
      button: _propTypes.default.shape(button),
      balanceDue: _propTypes.default.number,
      lastPaymentMethod: _propTypes.default.shape({
        name: _propTypes.default.string,
        currency: _propTypes.default.string,
        amount: _propTypes.default.string,
        dateTime: _propTypes.default.string,
        status: _propTypes.default.string
      }),
      bookingText: _propTypes.default.string,
      bookingId: _propTypes.default.string
    }).isRequired,
    isMobile: _propTypes.default.bool,
    handleBookingCallback: _propTypes.default.func,
    isToggleEnabled: _propTypes.default.bool,
    defaultToggle: _propTypes.default.bool,
    isloading: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    locale: 'en-gb',
    accessible: true,
    // translation: TRANSLATION,
    data: {},
    state: '',
    isMobile: false,
    handleBookingCallback: null,
    templateString: {},
    isloading: false,
    defaultToggle: true
  }
};
exports.default = _default;